import { Helmet } from "react-helmet";
import { Link, useNavigate, useParams } from "react-router-dom";

const classSlugToLabel = {
  "lkg": "LKG",
  "ukg": "UKG",
  "class-1": "Class 1",
  "class-2": "Class 2",
  "class-3": "Class 3",
  "class-4": "Class 4",
  "class-5": "Class 5",
  "class-6": "Class 6",
  "class-7": "Class 7"
};

const subjects = [
  { label: "English", slug: "english", count: 6 },
  { label: "Mathematics", slug: "maths", count: 7 },
  { label: "EVS", slug: "science" },
  { label: "Hindi", slug: "hindi" }
];

function GradeSubjectsPage(){
  const navigate = useNavigate();
  const { classSlug } = useParams();
  const classLabel = classSlugToLabel[classSlug] || "Class";

  return (
    <div style={{ minHeight: "100vh", padding: "28px", background: "#F7FAFF" }}>
      <Helmet>
        <title>{classLabel} Subjects – PracticeNest</title>
        <meta
          name="description"
          content={`Choose a subject for ${classLabel} worksheets.`}
        />
        <link rel="canonical" href={`https://practicenest.in/grades/${classSlug}`} />
      </Helmet>

      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "18px" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "6px 10px",
              borderRadius: "10px",
              border: "1px solid #cfd8e3",
              background: "#fff",
              cursor: "pointer"
            }}
          >
            ←
          </button>
          <Link to="/" style={{ textDecoration: "none", fontWeight: "600" }}>Home</Link>
        </div>

        <h1 style={{ fontSize: "32px", textAlign: "center", marginBottom: "24px" }}>
          {classLabel} – Subjects
        </h1>

        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "16px" }}>
          {subjects.map((s, idx) => (
            <Link
              key={`${s.slug}-${idx}`}
              to={`/worksheets/${classSlug}/${s.slug}`}
              style={{
                textDecoration: "none",
                color: "inherit",
                background: "#fff",
                padding: "20px",
                borderRadius: "16px",
                border: "1px solid #e6eef7",
                boxShadow: "0 6px 14px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
                <div style={{ fontSize: "22px", fontWeight: "700", color: "#5B6B7B", width: "36px" }}>
                  {String(idx + 1).padStart(2, "0")}
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700" }}>{s.label}</div>
                  {s.count !== undefined && (
                    <div style={{ fontSize: "14px", color: "#7A8896" }}>{s.count} subtopics</div>
                  )}
                </div>
              </div>
              <div style={{
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                border: "1px solid #cfd8e3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#9AA7B2",
                fontSize: "16px"
              }}>
                ▾
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GradeSubjectsPage;
